export default "__VITE_ASSET__zmI_BB5t__"